"use client";

import { ImportDialog } from "@/app/(views)/(signedIn)/settings/account/general/import";
import { useTour } from "@/context/TourContext";

const OnboardingImportModal = () => {
  const { tourState, closeImportModal } = useTour();

  const handleClose = () => {
    closeImportModal();
  };

  return (
    <ImportDialog
      isOpen={tourState.showImportModal}
      onClose={handleClose}
      title="Importar tus datos"
      description="Te ayudamos a importar tus datos existentes para que puedas empezar a usar Orquesti inmediatamente."
    />
  );
};

export default OnboardingImportModal;
